import { GlobalButton, NavigateLinks, BackToModuleButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { fleetPageBreadcrumbs } from '../config/breadcrumbs';
import { useMemo, useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useServicesPage, useServicesSearchOptions } from './hooks';
import {
  SearchBar,
  ServicesTable,
  ConfirmDeleteServiceModal,
} from './components';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
} from '@mui/icons-material';

const Services = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(() => fleetPageBreadcrumbs(navigate), [navigate]);
  const [businessesSearch, setBusinessesSearch] = useState('');

  const searchOptions = useServicesSearchOptions({ businessesSearch });

  const {
    filters,
    setFilters,
    currentPage,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
    deleteModal,
    openDeleteModal,
    closeDeleteModal,
    handleConfirmDelete,
    isDeleting,
  } = useServicesPage();

  const renderActions = (rowData: Record<string, unknown>) => (
    <>
      <Tooltip title="Ver">
        <IconButton
          onClick={() => navigate(`/fleet/services/${rowData.id}`)}
        >
          <ViewIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Eliminar">
        <IconButton
          onClick={() =>
            openDeleteModal(String(rowData.id), String(rowData.name ?? ''))
          }
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </>
  );

  return (
    <section className="w-full h-full flex flex-col gap-6">
      <NavigateLinks actualPage="Servicios" breadcrumbs={breadcrumbs} />

      <div className="flex justify-end gap-5">
        <BackToModuleButton breadcrumbs={breadcrumbs} />

        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate('/fleet/services/new')}
        >
          <AddIcon />
          Agregar servicio
        </GlobalButton>
      </div>

      <SearchBar
        filters={filters}
        onFiltersChange={setFilters}
        options={searchOptions}
        onBusinessSearchInputChange={setBusinessesSearch}
      />

      <ServicesTable
        filters={filters}
        page={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        renderActions={renderActions}
      />

      <ConfirmDeleteServiceModal
        open={deleteModal.open}
        serviceName={deleteModal.serviceName}
        isLoading={isDeleting}
        onClose={closeDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </section>
  );
};

export default Services;
